import { useMemo, useState } from "react";

import { useAuthUserQuery } from "modules/user/hooks/queries/useAuthUserQuery";

import BaseOnboardingModal from "../ui/BaseOnboardingModal";
import RoleAbilitiesStep from "./RoleAbilitiesStep";
import TeamUsageStep from "./TeamUsageStep";
import WorkspaceStep from "./WorkspaceStep";
import WelcomeStep from "./WelcomeStep";
import LastStep from "./LastStep";

import { getSteps } from "./constants";

type ViewerOnboardingModalProps = {
  isLoading?: boolean;
  onSubmit: () => void;
};

const ViewerOnboardingModal = (props: ViewerOnboardingModalProps) => {
  const { onSubmit, isLoading } = props;

  const [currentStep, setCurrentStep] = useState(0);

  const { data: userData } = useAuthUserQuery();

  const steps = useMemo(() => getSteps(userData), [userData]);

  return (
    <BaseOnboardingModal
      currentStep={currentStep}
      stepsCount={steps.length}
      title={steps[currentStep]?.title}
      sideContent={steps[currentStep]?.sideContent}
      status={steps[currentStep]?.status}
      goNext={() => setCurrentStep(prev => prev + 1)}
      onSubmit={onSubmit}
      submitLabel="Checkout My Teams backlogs"
      isSubmitting={isLoading}
    >
      {currentStep === 0 && <WelcomeStep />}

      {currentStep === 1 && <WorkspaceStep />}

      {currentStep === 2 && <TeamUsageStep />}

      {currentStep === 3 && <RoleAbilitiesStep />}

      {currentStep === 4 && <LastStep />}
    </BaseOnboardingModal>
  );
};

export default ViewerOnboardingModal;
